module.exports = __webpack_public_path__ + "static/media/Chime2.bfcce14d.mp3";